import {
  ADDCARDETAILS,
  ADDCARNUMBER,
  ALLCARDETAILS,
  CARNUMFLAG,
  CAR_INS_PRODUCT,
  PREV_INS_LIST,
  QUICKQUOTES,
  SUMINSURANCE_AMOUNT,
  QUICKQUOTE_POST_CAR,
  QUICKQUOE_VALUE_CAR,
  PREV_POLICY_DETAIL_CAR,
  RESET_CAR,
  ERROR_QUOTES_CAR,
  CREATE_CRPROPOSAL,
  PAYMENT_CRREQUEST,
  KYC_CRSTATUS,
  POLICY_CRPDF,
  BREAKIN_POLICY,
  TRANS_ID_CAR,
} from "../actiontypes/NumCarActiontypes";

const init = {
  iscarno: false,
  carMakeData: {},
  isallcardetails: false,
  insuranceproduct: [],
  previnslist: [],
  quickquotes: [],
  errquote: [],
  Breakin: [],
  quickQuotePost: {},
  quoteInput: {},
  prevpolicydetail: {},
  createProposal: {},
  payRequest: {},
  KycStatus: {},
  policypdf: {},
  Tid: {},
  suminsured: [],
};
export const numCarReducer = (state = init, { type, payload }) => {
  switch (type) {
    case ADDCARNUMBER:
      return { ...state, carnum: payload, iscarno: true };
    case CARNUMFLAG:
      return { ...state, carnum: "", iscarno: false };
    case ADDCARDETAILS:
      return {
        ...state,
        carMakeData: payload,
        isallbikedetails: true,
      };
    case ALLCARDETAILS:
      return { ...state, isallcardetails: true };
    case CAR_INS_PRODUCT:
      return { ...state, insuranceproduct: payload };
    case PREV_INS_LIST:
      return { ...state, previnslist: payload };
    case QUICKQUOTES:
      return { ...state, quickquotes: payload };
    case QUICKQUOTE_POST_CAR:
      return { ...state, quickQuotePost: payload };
    case QUICKQUOE_VALUE_CAR:
      return { ...state, quoteInput: payload };
    case ERROR_QUOTES_CAR:
      return { ...state, errquote: payload };
    case BREAKIN_POLICY:
      return { ...state, Breakin: payload };
    case PREV_POLICY_DETAIL_CAR:
      return { ...state, prevpolicydetail: payload };
    case SUMINSURANCE_AMOUNT:
      return { ...state, suminsured: payload };
    case CREATE_CRPROPOSAL:
      return { ...state, createProposal: payload };
    case PAYMENT_CRREQUEST:
      return { ...state, payRequest: payload };
    case KYC_CRSTATUS:
      return { ...state, KycStatus: payload };
    case POLICY_CRPDF:
      return { ...state, policypdf: payload };
    case TRANS_ID_CAR:
      return { ...state, Tid: payload };
    case RESET_CAR:
      return init;
    default:
      return { ...state };
  }
};
